// Constantes de mercados para la aplicación

// Sugerencias de mercados populares
export const SUGGESTED_MARKETS = [
  // USA
  { ticker: 'AAPL', name: 'Apple', region: 'USA' },
  { ticker: 'MSFT', name: 'Microsoft', region: 'USA' },
  { ticker: 'GOOGL', name: 'Alphabet', region: 'USA' },
  { ticker: 'AMZN', name: 'Amazon', region: 'USA' },
  { ticker: 'TSLA', name: 'Tesla', region: 'USA' },
  { ticker: 'NVDA', name: 'NVIDIA', region: 'USA' },
  { ticker: 'META', name: 'Meta', region: 'USA' },
  { ticker: 'NFLX', name: 'Netflix', region: 'USA' },
  { ticker: 'JPM', name: 'JPMorgan', region: 'USA' },
  { ticker: 'V', name: 'Visa', region: 'USA' },
  { ticker: 'DIS', name: 'Disney', region: 'USA' },
  // España
  { ticker: 'REP.MC', name: 'Repsol', region: 'España' },
  { ticker: 'SAN.MC', name: 'Santander', region: 'España' },
  { ticker: 'BBVA.MC', name: 'BBVA', region: 'España' },
  { ticker: 'ITX.MC', name: 'Inditex', region: 'España' },
  { ticker: 'TEF.MC', name: 'Telefónica', region: 'España' },
  { ticker: 'IBE.MC', name: 'Iberdrola', region: 'España' },
  { ticker: 'FER.MC', name: 'Ferrovial', region: 'España' },
  { ticker: 'ACS.MC', name: 'ACS, Actividades de Construcción y Servicios (TR)', region: 'España' },
  { ticker: 'ENG.MC', name: 'Enagás', region: 'España' },
  { ticker: 'GRF.MC', name: 'Grifols', region: 'España' },
  // Europa
  { ticker: 'SAP', name: 'SAP SE', region: 'Europa' },
  { ticker: 'ASML', name: 'ASML', region: 'Europa' },
  { ticker: 'OR.PA', name: "L'Oréal", region: 'Europa' },
  { ticker: 'MC.PA', name: 'LVMH', region: 'Europa' },
  { ticker: 'BMW.DE', name: 'BMW', region: 'Europa' },
  { ticker: 'SIE.DE', name: 'Siemens', region: 'Europa' },
  { ticker: 'NESN.SW', name: 'Nestlé', region: 'Europa' },
  { ticker: 'NOVN.SW', name: 'Novartis', region: 'Europa' },
  // Asia
  { ticker: '7203.T', name: 'Toyota', region: 'Asia' },
  { ticker: '9984.T', name: 'SoftBank', region: 'Asia' },
  { ticker: '6758.T', name: 'Sony', region: 'Asia' },
  { ticker: '9432.T', name: 'NTT', region: 'Asia' },
  { ticker: '7267.T', name: 'Honda', region: 'Asia' },
  { ticker: '6861.T', name: 'Keyence', region: 'Asia' },
  { ticker: '9988.HK', name: 'Alibaba HK', region: 'Asia' },
  { ticker: '0700.HK', name: 'Tencent', region: 'Asia' },
  { ticker: '9618.HK', name: 'JD.com', region: 'Asia' },
  { ticker: '1299.HK', name: 'AIA Group', region: 'Asia' },
  { ticker: '005930.KS', name: 'Samsung', region: 'Asia' },
  { ticker: 'BABA', name: 'Alibaba US', region: 'Asia' },
  { ticker: 'NIO', name: 'NIO', region: 'Asia' },
  { ticker: 'BIDU', name: 'Baidu', region: 'Asia' },
  // Materias Primas
  { ticker: 'GC=F', name: 'Oro', region: 'Materias Primas' },
  { ticker: 'SI=F', name: 'Plata', region: 'Materias Primas' },
  { ticker: 'CL=F', name: 'Petróleo WTI', region: 'Materias Primas' },
  { ticker: 'NG=F', name: 'Gas Natural', region: 'Materias Primas' },
  { ticker: 'HG=F', name: 'Cobre', region: 'Materias Primas' },
  // Crypto
  { ticker: 'BTC-USD', name: 'Bitcoin', region: 'Crypto' },
  { ticker: 'ETH-USD', name: 'Ethereum', region: 'Crypto' },
  { ticker: 'SOL-USD', name: 'Solana', region: 'Crypto' },
  { ticker: 'XRP-USD', name: 'Ripple', region: 'Crypto' },
  // Fondos Indexados
  { ticker: 'VGEU.DE', name: 'Vanguard European Stock Index', region: 'Fondos Indexados' },
  { ticker: 'EUNM.DE', name: 'iShares Emerging Markets Index', region: 'Fondos Indexados' },
  { ticker: 'IWDA.AS', name: 'Fidelity MSCI World Index', region: 'Fondos Indexados' },
];

export const DEFAULT_MARKETS = [
  // USA
  { ticker: 'META', name: 'Meta Platforms', region: 'USA' },
  { ticker: 'NVDA', name: 'NVIDIA', region: 'USA' },
  { ticker: 'MSFT', name: 'Microsoft', region: 'USA' },
  { ticker: 'AAPL', name: 'Apple', region: 'USA' },
  { ticker: 'GOOGL', name: 'Alphabet', region: 'USA' },
  { ticker: 'AMZN', name: 'Amazon', region: 'USA' },
  { ticker: 'TSLA', name: 'Tesla', region: 'USA' },
  // Europa
  { ticker: 'SAP', name: 'SAP SE', region: 'Europa' },
  // España
  { ticker: 'SAN.MC', name: 'Santander', region: 'España' },
  // Crypto
  { ticker: 'BTC-USD', name: 'Bitcoin', region: 'Crypto' },
];

// Regiones disponibles para filtrado
export const REGIONS = ['all', 'USA', 'España', 'Europa', 'Asia', 'Materias Primas', 'Crypto', 'Fondos Indexados'];

// Detectar si un ticker es europeo (cotiza en EUR nativo)
export const isEuropeanTicker = (ticker) => {
  return ticker.endsWith('.MC') || 
         ticker.endsWith('.DE') || 
         ticker.endsWith('.PA') || 
         ticker.endsWith('.SW') ||
         ticker.endsWith('.L') ||
         ticker.endsWith('.AS') ||
         ticker.endsWith('.MI');
};

// Detectar si un ticker cotiza en EUR NATIVO (bolsa denominada en euros).
// A diferencia de isEuropeanTicker, aquí EXCLUIMOS .SW (Suiza, CHF) y .L (Londres, GBP)
// porque esas plazas NO cotizan en EUR y su precio SÍ necesita conversión.
// Se usa para evitar la DOBLE CONVERSIÓN (parpadeo rojo↔verde): cuando el backend,
// bajo rate-limit de yfinance, no manda current_price_eur y reporta mal la moneda
// (currency por defecto 'USD'), NO debemos multiplicar por el cambio un precio que ya
// está en EUR. Sufijos de plazas en euros:
export const EUR_EXCHANGE_SUFFIXES = ['.DE', '.MC', '.PA', '.AS', '.MI', '.BR', '.LS', '.VI', '.HE', '.IR', '.F', '.SG', '.MU', '.BE', '.HM', '.DU', '.STU', '.ETR'];
export const isEurDenominatedTicker = (ticker) => {
  const t = (ticker || '').toUpperCase();
  return EUR_EXCHANGE_SUFFIXES.some((suf) => t.endsWith(suf));
};

// Detectar si un ticker es mexicano (BMV, sufijo .MX en yfinance)
export const isMexicanTicker = (ticker) => (ticker || '').toUpperCase().endsWith('.MX');

// Detectar si un ticker es crypto
export const isCryptoTicker = (ticker) => {
  return ticker.includes('-USD') || 
         ticker.includes('-EUR') || 
         ticker === 'BTC' || 
         ticker === 'ETH';
};
